import {Helmet} from "react-helmet";
import {Alert, Button, Container, Fade, Grid, TextField, Typography} from "@mui/material";
import SkyBlueWrapper from "../../../theme/components/SkyBlueWrapper";
import Toasty from "../../../theme/components/Toasty";
import {validateEmail, validatePhoneNumber} from "../../../lib/commonFunctions/regexValidators";
import {requestShareFile} from "../../../lib/services/drive";
import {useState} from "react";
import CustomInput from "../../../theme/components/CustomInput";
import {LoadingButton} from "../../../theme/components/LoadingButton";
import AddressBookModal from "../../../components/common/addressBookModal";
import LoginModal from "../../../components/common/loginModal";
import {useUser} from "../../../lib/hooks";

export default function RequestShare() {

    const user = useUser();
    const [inputsData, setInputsData] = useState({
        sender: '',
        senderError: false,
        title: '',
        titleError: false,
        description: '',
    });
    const [addressBookModalOpen, setAddressBookModalOpen] = useState(false);
    const [loginModal, setLoginModal] = useState(false);
    const [pending, setPending] = useState(false);
    const [success, setSuccess] = useState(false);
    const [linkAddress, setLinkAddress] = useState('');

    const handleInputChange = (e) => {
        const {target: {value, name}} = e;
        setInputsData({...inputsData, senderError: false, titleError: false, [name]: value});
    }
    const handleSubmit = async (e, isLoggedIn) => {
        e.preventDefault();
        if (!user && !isLoggedIn) return setLoginModal(true);
        const {sender, title, description} = inputsData;
        if (!title) {
            setInputsData({...inputsData, titleError: true});
            return Toasty.error('لطفا عنوان را وارد کنید')
        }
        if (Boolean(validateEmail(sender)) || Boolean(validatePhoneNumber(sender))) {
            setPending(true);
            // Everything is good
            try {
                const {data} = await requestShareFile(sender, title, description);
                if (data?.isSuccess) {
                    setLinkAddress(data.value?.linkAddress);
                    setSuccess(true);
                } else {
                    if (data && data.errors?.length) {
                        data.errors.map(i => Toasty.error(i));
                    }
                }
            } catch (err) {
                console.log(err);
                Toasty.error('خطایی غیر منتظره رخ داد')
            }
            setPending(false);
        } else {
            setInputsData({...inputsData, senderError: true})
            Toasty.error('مقدار وارد شده باید یا ایمیل یا شماره (به حروف لاتین) باشد')
        }
    }

    return (
        <>
            <Helmet>
                <title>درخواست اشتراک گذاری - میلفا</title>
            </Helmet>
            <Container sx={{ mt: 3 }}>
                <Typography variant="h1" fontSize={{ xs: "1.15rem", lg: "1.25rem" }} fontWeight={700}>درخواست ارسال اشتراک گذاری</Typography>
            </Container>
            <SkyBlueWrapper sx={{ mt: 3, mb: 6, py: 5 }}>
                <Container>
                    <Alert severity="info" sx={{ display: "inline-flex" }}>با فرستادن درخواست، برای فرد مورد نظر پیامکی حاوی لینک و اطلاعات درخواست ارسال خواهد شد.</Alert>
                    <Grid mt={1} component="form" onSubmit={handleSubmit} noValidate container spacing={2}>
                        <Grid item xs={12} lg={4}>
                            <CustomInput
                                value={inputsData.sender} onChange={handleInputChange}
                                name="sender" fullWidth error={!!inputsData.senderError}
                                placeholder="شماره موبایل یا ایمیل فرد مورد نظر خود را وارد کنید"/>
                        </Grid>
                        <Grid item xs={12} lg={3}>
                            <Button
                                onClick={() => setAddressBookModalOpen(true)}
                                variant="contained" fullWidth
                                sx={{ py: 1.5, height: 1, backgroundColor: theme => theme.palette.primary.light, color: theme => theme.palette.primary.main, "&:hover": {background: "#81d4fa"} }} disableElevation>انتخاب از دفترچه آدرس</Button>
                        </Grid>
                        <Grid item xs={12} container spacing={2}>
                            <Grid item xs={12} lg={7}>
                                <CustomInput
                                    value={inputsData.title} onChange={handleInputChange}
                                    name="title" error={!!inputsData.titleError}
                                    placeholder="عنوان" fullWidth/>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <CustomInput
                                value={inputsData.description} onChange={handleInputChange}
                                name="description" fullWidth required
                                error={!!inputsData.descriptionError}
                                multiline minRows={8}
                                placeholder="لطفا توضیحات خود را وارد کنید"/>
                        </Grid>
                        <Grid item xs={12} lg={5}>
                            <LoadingButton
                                type="submit" loading={pending}
                                fullWidth sx={{py: 1.5, height: 1, backgroundColor: theme => theme.palette.primary.light, color: theme => theme.palette.primary.main, "&:hover": {background: "#81d4fa"}}}
                                disableElevation>ارسال درخواست</LoadingButton>
                        </Grid>
                        <Grid item xs={12} lg={7}>
                            <Fade in={success}>
                                <Alert severity="success" sx={{ height: 1 }}>درخواست شما با موفقیت ارسال شد، کد اشتراک گذاری: {linkAddress}</Alert>
                            </Fade>
                        </Grid>
                    </Grid>
                </Container>
            </SkyBlueWrapper>

            {/* Address Book Modal */}
            <AddressBookModal
                open={addressBookModalOpen}
                onClose={() => setAddressBookModalOpen(false)}
                multiSelect={false}
                onConfirm={(payload) => {setInputsData({...inputsData, sender: payload}); setAddressBookModalOpen(false)}}/>

            <LoginModal
            open={loginModal}
            onClose={() => setLoginModal(false)}
            options={{ noReload: true, onSuccess: (e) => handleSubmit(e, true) }}/>
        </>
    )
}